import { ReplayWidget } from '@/components/ReplayWidget'
import '@/styles/widget.css'
import React from 'react'
import ReactDOM from 'react-dom/client'
const _react = React
const _reactDOM = ReactDOM

let widgetRoot = null
let targetElement = null

function initWidget(element, data) {
  if (!element) {
    console.error('No target element provided for widget initialization')
    return
  }

  // If target element changed, create new root
  if (targetElement !== element) {
    if (widgetRoot) {
      widgetRoot.unmount()
      widgetRoot = null
    }
    targetElement = element
  }

  // Create new root if needed
  if (!widgetRoot) {
    try {
      widgetRoot = ReactDOM.createRoot(targetElement)
    } catch (error) {
      console.error('Failed to create root:', error)
      return
    }
  }

  // Render or update the widget
  try {
    widgetRoot.render(<ReplayWidget data={data} />)
  } catch (error) {
    console.error('Failed to render widget:', error)
    // Reset root if render fails
    widgetRoot = null
    targetElement = null
  }
}

declare global {
  interface Window {
    replayWidget: typeof initWidget
  }
}

if (typeof window !== 'undefined') {
  window.replayWidget = initWidget
}

export { initWidget }
